import Blue from "~/core";
import Splide from '@splidejs/splide';

new Blue({
  name: "AviationNews",
  selector: ".aviation-news",
  setup(aviationNews) {
    const shouldSetTimeout = document.querySelector("html").classList.contains("kentico-page-builder");
    if (shouldSetTimeout) {
      //updateSplideMethodList({
        //initAviationNewsSplide
      //});
    } else {
      initAviationNewsSplide();
    }
  },
});

function initAviationNewsSplide() {

  var splideElement = document.querySelector('.aviation-news .splide');

  if (splideElement) {

    const aviationNewsSplide = new Splide(splideElement, {
      type: 'loop',
      perPage: 3,
      perMove: 3,
      pagination: false,
      gap: '1rem',
      fixedWidth: 340,
      mediaQuery: 'min',
      breakpoints: {
        728: {
          gap: '2rem',
          fixedWidth: 400
        },
        1024: {
          fixedWidth: 450
        }
      },
    });
    
    aviationNewsSplide.mount();

    const nextButton = document.querySelector('.aviation__splide-arrow--next');
    const prevButton = document.querySelector('.aviation__splide-arrow--prev');

    nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        aviationNewsSplide.go(aviationNewsSplide.index + 1);
    });

    prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        aviationNewsSplide.go(aviationNewsSplide.index - 1);
    });
  }
}

function updateSplideMethodList(functionList) {
  if(window.splideMethods)
  {
    Object.assign(window.splideMethods, functionList);
  }
  else {
    window.splideMethods = functionList;
  }
}
